// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3BqhV","imageUploader":"EGiftCard_imageUploader__oQW3R"};